import { getInstance } from '../lib/component';
import { getClosestByClass } from '../lib/helper';
import { triggerEvent } from '../lib/helper';
import Selector from './Selector';
import Tabs from './Tabs';
import TabsSwipeable from './TabsSwipeable';

/**
 * Handles a tc-tabs element.
 * @type {Class}
 */
export default class TabSelector extends Selector {

  constructor(el) {

    super(el);

    this.el = el;
    this.relatedTabWrapper = getClosestByClass(this.el, this.el.getAttribute('data-tab-wrapper')) || getClosestByClass(this.el, 'tc-tabs');
    this.options = [].slice.call(this.el.querySelectorAll('option'));
    this.correspondingModule = this.el.getAttribute('data-module') || 'Tabs';

    // get the corresponding tab-module
    this.moduleImport = this.correspondingModule.indexOf('TabsSwipeable') > -1 ? TabsSwipeable : Tabs;
    this.tabInstance = getInstance(this.moduleImport, this.relatedTabWrapper);

    if (!this.tabInstance) {

      return;
    }

    this.prepareTabs();
    this.registerTabSelectorEvents();
  }

  registerTabSelectorEvents() {

    this.select.addEventListener('change', this.onChangeTabSelector.bind(this), false);

    if (!this.tabInstance.onlySelectorControl) {

      this.tabInstance.el.addEventListener('tabChange', this.onTabChange.bind(this), false);
    }
  }

  prepareTabs() {

    this.options.map(option => {

      const tabTrigger = document.querySelector('[data-tab-id="' + option.value + '"]');

      option.targetTabTrigger = tabTrigger;

      return option;
    });
  }

  onChangeTabSelector() {

    const option = this.select.querySelector('option:checked');

    if (this.tabInstance.onlySelectorControl) {

      this.tabInstance.onClick(option);
    } else {

      if (option.targetTabTrigger.classList.contains('active')) {

        return;
      }

      this.tabInstance.onClick(option.targetTabTrigger);
    }
  }

  onTabChange(e) {

    const targetId = this.tabInstance.activeTrigger.getAttribute('data-tab-id');

    for (let i = 0; i < this.select.options.length; i++) {

      if (this.select.options[i].value === targetId) {

        this.select.selectedIndex = i;
        triggerEvent(this.select, 'change');
        break;
      }
    }
  }
};
